module.exports = __webpack_public_path__ + "static/fonts/Poppins-Black.14d00da.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Poppins-Black.ttf
// module id = 1019
// module chunks = 11